import React from 'react';
import { motion } from 'framer-motion';
import { HeroData } from '../../data/data';

interface HeroProps {
  data: HeroData;
}

const Hero: React.FC<HeroProps> = ({ data }) => {
  return (
    <section id="hero" className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center relative overflow-hidden section-padding">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="grid gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {data.name}
              </h1> 
              <h2 className="text-2xl lg:text-3xl font-semibold text-edata-blue mt-2">
                {data.title}
              </h2>
              <p className="text-xl text-gray-600 mt-4">
                {data.subtitle}
              </p>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="text-lg text-gray-700 leading-relaxed"
            >
              {data.description}
            </motion.p>
          </motion.div> 
        </div> 
      </div>
    </section>
  );
};

export default Hero; 